import script from "./ElderlyInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ElderlyInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./ElderlyInfoCard.vue?vue&type=style&index=0&id=c263f112&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c263f112"]])

export default __exports__